import React, { useState, useEffect } from 'react';
import animateScrollTo from 'animated-scroll-to';
import {
    useParams, useHistory, Redirect,
} from 'react-router-dom';
import Helmet from 'react-helmet';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import parseTerms from '../../../helpers/parseTerms';
import ErrorPage from '../../../common/errorPage/ErrorPage';

const htmlPrivacy = require('../data/htmlPrivacy');
const htmlUse = require('../data/htmlUse');

const TermsComponent = () => {
    const { slug } = useParams();
    const history = useHistory();
    const [currentTerms, setCurrentTerms] = useState(slug);

    const _showTermsUse = () => {
        setCurrentTerms('uso');

        history.push('/termos/uso');
    };

    const _showPrivacy = () => {
        setCurrentTerms('privacidade');

        history.push('/termos/privacidade');
    };

    useEffect(() => { animateScrollTo(0, { speed: 700 }); }, []);

    if (!slug) {
        // rendered directly (not inside a useEffect) so that during SSR the StaticRouter
        // context picks up the redirect and server.js can issue a real HTTP redirect
        return <Redirect to="/termos/privacidade" />;
    }

    if (slug !== 'privacidade' && slug !== 'uso') {
        return <ErrorPage
            errorNumber={404}
            backLink="/termos"
            title="NÃO ACHAMOS ESSES TERMOS :("
            message="Verifique se o link foi digitado corretamente."
            buttonText="Clique aqui para voltar para a página com todos os termos"
        />;
    }

    return (
        <div>
            <Helmet
                key="termos"
                title={currentTerms === 'privacidade' ? 'Política de Privacidade' : 'Termos de Uso'}
                meta={[{ property: 'og:title', content: currentTerms === 'privacidade' ? 'Política de Privacidade' : 'Termos de Uso' }]}
            />
            <section className="sectionTerms">
                <div className="containerButton">
                    <Button
                        className={currentTerms === 'privacidade' ? 'actButton btnPrivacy' : 'btnPrivacy'}
                        title="Políticas de Privacidade"
                        onClick={() => _showPrivacy()}
                    >
                        Políticas de Privacidade
                    </Button>
                    <Button
                        className={currentTerms === 'uso' ? 'actButton btnUseTerms' : 'btnUseTerms'}
                        title="Termos de uso"
                        onClick={() => _showTermsUse()}
                    >
                        Termos de Uso
                    </Button>
                </div>
                <div className="containerTerms">
                    {
                        currentTerms === 'privacidade' ?
                            parseTerms(htmlPrivacy) :
                            parseTerms(htmlUse)
                    }
                </div>
            </section>
        </div>
    );
};

TermsComponent.propTypes = exact({});

export default TermsComponent;
